// GENERATED by auto/gen-build-forms-geometry.mjs — DO NOT EDIT BY HAND.
// A verbatim in-code copy of the shipped forms.ini sections for the in-game build/recruit/
// research/place/unit-menu forms (game/res.h ids 1008/1011/1012/1013/1014/1015/1016/1017/1018/1030/1031/1032/1045). The BuildUI
// Forms Init against THIS data (not the shipped forms.ini in the pdb), so buildui's in-game UI
// is no longer a forms.ini Form. The parse/scale/InitParts code path that consumes it is the
// SAME one the runtime forms.ini load uses → control trees are byte-identical (proven by
// test/client/build-forms-geometry.test.ts, which regenerates this from the live forms.ini).
import type { IniSection } from '../../../sim/src/data/ini.ts';

export const kBuildFormSections: IniSection[] = [
  {
    name: '1008',
    props: [
      {
        key: 'FORM',
        value: '(0 0 66 68) 2001',
      },
      {
        key: 'LABEL',
        value: '1200 (0 2 66 0) "" 3 center',
      },
      {
        key: 'BUTTON',
        value:
          '1304 (3 14 60 12) "" 2 nocenter build_btn_up.tbm build_btn_down.tbm build_btn_disabled.tbm',
      },
      {
        key: 'BUTTON',
        value:
          '1300 (3 31 60 12) "" 2 nocenter repair_btn_up.tbm repair_btn_down.tbm repair_btn_disabled.tbm',
      },
      {
        key: 'BUTTON',
        value: '1303 (3 31 60 12) "" 2 nocenter abort_repair_btn_up.tbm abort_repair_btn_down.tbm',
      },
      {
        key: 'BUTTON',
        value:
          '1301 (3 48 60 12) "" 2 nocenter sell_btn_up.tbm sell_btn_down.tbm sell_btn_disabled.tbm',
      },
    ],
  },
  {
    name: '1011',
    props: [
      {
        key: 'FORM',
        value: '(0 0 160 143) 2001',
      },
      {
        key: 'LABEL',
        value: '0 (2 5 82 0) "RECRUIT PERSONNEL" 3',
      },
      {
        key: 'BUTTON',
        value: '2004 (135 3 10 12) "" 2 nocenter helpup.tbm helpdown.tbm',
      },
      {
        key: 'BUTTON',
        value: '2001 (147 3 10 12) "" 2 nocenter cancelup.tbm canceldown.tbm',
      },
      {
        key: 'ANIMLIST',
        value: '1007 (-1 17 28 121) 1 17',
      },
      {
        key: 'LABEL',
        value: '1010 (30 79 127 8) "" 1 left multiline',
      },
      {
        key: 'LABEL',
        value: '1001 (30 19 75 0) "" 1',
      },
      {
        key: 'LABEL',
        value: '0 (30 31 22 0) "COST" 1',
      },
      {
        key: 'LABEL',
        value: '0 (30 40 22 0) "ARMOR" 1',
      },
      {
        key: 'LABEL',
        value: '0 (30 49 22 0) "DAMAGE" 1',
      },
      {
        key: 'LABEL',
        value: '0 (30 58 22 0) "SPEED" 1',
      },
      {
        key: 'LABEL',
        value: '0 (30 67 22 0) "RANGE" 1',
      },
      {
        key: 'LABEL',
        value: '1002 (136 31 22 0) "" 1 right',
      },
      {
        key: 'LABEL',
        value: '1004 (136 40 22 0) "" 1 right',
      },
      {
        key: 'LABEL',
        value: '1003 (136 58 22 0) "" 1 right',
      },
      {
        key: 'LABEL',
        value: '1006 (136 67 22 0) "" 1 right',
      },
      {
        key: 'LABEL',
        value: '1200 (33 123 32 12) "Limit Reached" 1 multiline center',
      },
      {
        key: 'BUTTON',
        value: '1008 (30 124 32 12) "Order" 2',
      },
      {
        key: 'BUTTON',
        value: '1009 (65 124 59 12) "Cancel Order" 2',
      },
      {
        key: 'BUTTON',
        value: '2000 (127 124 31 12) "Close" 2',
      },
      {
        key: 'PIPMETER',
        value: '1101 (64 31 71 9)',
      },
      {
        key: 'PIPMETER',
        value: '1104 (64 40 71 9)',
      },
      {
        key: 'DAMAGEMETER',
        value: '1105 (64 49 94 9)',
      },
      {
        key: 'PIPMETER',
        value: '1103 (64 58 71 9)',
      },
      {
        key: 'PIPMETER',
        value: '1106 (64 67 71 9)',
      },
    ],
  },
  {
    name: '1012',
    props: [
      {
        key: 'FORM',
        value: '(0 0 76 68) 2001',
      },
      {
        key: 'LABEL',
        value: '1200 (0 2 76 0) "" 3 center',
      },
      {
        key: 'BUTTON',
        value:
          '1305 (3 14 60 12) "" 2 nocenter build_btn_up.tbm build_btn_down.tbm build_btn_disabled.tbm',
      },
      {
        key: 'BUTTON',
        value: '1304 (3 14 60 12) "" 2 nocenter abort_build_btn_up.tbm abort_build_btn_down.tbm',
      },
      {
        key: 'BUTTON',
        value:
          '1300 (3 31 60 12) "" 2 nocenter repair_btn_up.tbm repair_btn_down.tbm repair_btn_disabled.tbm',
      },
      {
        key: 'BUTTON',
        value: '1303 (3 31 60 12) "" 2 nocenter abort_repair_btn_up.tbm abort_repair_btn_down.tbm',
      },
      {
        key: 'BUTTON',
        value:
          '1301 (3 48 60 12) "" 2 nocenter sell_btn_up.tbm sell_btn_down.tbm sell_btn_disabled.tbm',
      },
    ],
  },
  {
    name: '1013',
    props: [
      {
        key: 'FORM',
        value: '(0 0 66 51) 2001',
      },
      {
        key: 'LABEL',
        value: '1200 (0 2 66 0) "" 3 center',
      },
      {
        key: 'BUTTON',
        value:
          '1300 (3 31 60 12) "" 2 nocenter repair_btn_up.tbm repair_btn_down.tbm repair_btn_disabled.tbm',
      },
      {
        key: 'BUTTON',
        value: '1303 (3 31 60 12) "" 2 nocenter abort_repair_btn_up.tbm abort_repair_btn_down.tbm',
      },
      {
        key: 'BUTTON',
        value:
          '1301 (3 48 60 12) "" 2 nocenter sell_btn_up.tbm sell_btn_down.tbm sell_btn_disabled.tbm',
      },
    ],
  },
  {
    name: '1014',
    props: [
      {
        key: 'FORM',
        value: '(0 0 66 68) 2001',
      },
      {
        key: 'LABEL',
        value: '1200 (0 2 66 0) "" 3 center',
      },
      {
        key: 'BUTTON',
        value:
          '1304 (3 14 60 12) "" 2 nocenter build_btn_up.tbm build_btn_down.tbm build_btn_disabled.tbm',
      },
      {
        key: 'BUTTON',
        value:
          '1300 (3 31 60 12) "" 2 nocenter repair_btn_up.tbm repair_btn_down.tbm repair_btn_disabled.tbm',
      },
      {
        key: 'BUTTON',
        value: '1303 (3 31 60 12) "" 2 nocenter abort_repair_btn_up.tbm abort_repair_btn_down.tbm',
      },
      {
        key: 'BUTTON',
        value:
          '1301 (3 48 60 12) "" 2 nocenter sell_btn_up.tbm sell_btn_down.tbm sell_btn_disabled.tbm',
      },
    ],
  },
  {
    name: '1015',
    props: [
      {
        key: 'FORM',
        value: '(0 0 160 143) 2001',
      },
      {
        key: 'LABEL',
        value: '0 (2 5 82 0) "ORDER VEHICLE" 3',
      },
      {
        key: 'BUTTON',
        value: '2004 (135 3 10 12) "" 2 nocenter helpup.tbm helpdown.tbm',
      },
      {
        key: 'BUTTON',
        value: '2001 (147 3 10 12) "" 2 nocenter cancelup.tbm canceldown.tbm',
      },
      {
        key: 'ANIMLIST',
        value: '1007 (-1 17 28 121) 1 17',
      },
      {
        key: 'LABEL',
        value: '1010 (30 79 127 8) "" 1 left multiline',
      },
      {
        key: 'LABEL',
        value: '1001 (30 19 75 0) "" 1',
      },
      {
        key: 'LABEL',
        value: '0 (30 31 22 0) "COST" 1',
      },
      {
        key: 'LABEL',
        value: '0 (30 40 22 0) "ARMOR" 1',
      },
      {
        key: 'LABEL',
        value: '0 (30 49 22 0) "DAMAGE" 1',
      },
      {
        key: 'LABEL',
        value: '0 (30 58 22 0) "SPEED" 1',
      },
      {
        key: 'LABEL',
        value: '0 (30 67 22 0) "RANGE" 1',
      },
      {
        key: 'LABEL',
        value: '1002 (136 31 22 0) "" 1 right',
      },
      {
        key: 'LABEL',
        value: '1004 (136 40 22 0) "" 1 right',
      },
      {
        key: 'LABEL',
        value: '1003 (136 58 22 0) "" 1 right',
      },
      {
        key: 'LABEL',
        value: '1006 (136 67 22 0) "" 1 right',
      },
      {
        key: 'LABEL',
        value: '1200 (33 123 32 12) "Limit Reached" 1 multiline center',
      },
      {
        key: 'BUTTON',
        value: '1008 (30 124 32 12) "Order" 2',
      },
      {
        key: 'BUTTON',
        value: '1009 (65 124 59 12) "Cancel Order" 2',
      },
      {
        key: 'BUTTON',
        value: '2000 (127 124 31 12) "Close" 2',
      },
      {
        key: 'PIPMETER',
        value: '1101 (64 31 71 9)',
      },
      {
        key: 'PIPMETER',
        value: '1104 (64 40 71 9)',
      },
      {
        key: 'DAMAGEMETER',
        value: '1105 (64 49 94 9)',
      },
      {
        key: 'PIPMETER',
        value: '1103 (64 58 71 9)',
      },
      {
        key: 'PIPMETER',
        value: '1106 (64 67 71 9)',
      },
    ],
  },
  {
    name: '1016',
    props: [
      {
        key: 'FORM',
        value: '(0 0 66 68) 2001',
      },
      {
        key: 'LABEL',
        value: '1200 (0 2 66 0) "" 3 center',
      },
      {
        key: 'BUTTON',
        value:
          '1304 (0 14 0 0) "" 2 nocenter build_btn_up.tbm build_btn_down.tbm build_btn_disabled.tbm',
      },
      {
        key: 'BUTTON',
        value: '1302 (0 14 0 0) "" 2 nocenter abort_build_btn_up.tbm abort_build_btn_down.tbm',
      },
      {
        key: 'BUTTON',
        value:
          '1300 (14 14 0 0) "" 2 nocenter repair_btn_up.tbm repair_btn_down.tbm repair_btn_disabled.tbm',
      },
      {
        key: 'BUTTON',
        value: '1303 (14 14 0 0) "" 2 nocenter abort_repair_btn_up.tbm abort_repair_btn_down.tbm',
      },
      {
        key: 'BUTTON',
        value:
          '1301 (28 14 0 0) "" 2 nocenter sell_btn_up.tbm sell_btn_down.tbm sell_btn_disabled.tbm',
      },
    ],
  },
  {
    name: '1017',
    props: [
      {
        key: 'FORM',
        value: '(0 0 160 143) 2001',
      },
      {
        key: 'LABEL',
        value: '0 (2 5 82 0) "ORDER BUILDING" 3',
      },
      {
        key: 'BUTTON',
        value: '2004 (135 3 10 12) "" 2 nocenter helpup.tbm helpdown.tbm',
      },
      {
        key: 'BUTTON',
        value: '2001 (147 3 10 12) "" 2 nocenter cancelup.tbm canceldown.tbm',
      },
      {
        key: 'ANIMLIST',
        value: '1007 (-1 17 28 121) 1 18',
      },
      {
        key: 'LABEL',
        value: '1010 (30 79 127 8) "" 1 left multiline',
      },
      {
        key: 'LABEL',
        value: '1001 (30 19 75 0) "UNIT NAME" 1',
      },
      {
        key: 'LABEL',
        value: '0 (30 31 22 0) "COST" 1',
      },
      {
        key: 'LABEL',
        value: '0 (30 40 22 0) "ARMOR" 1',
      },
      {
        key: 'LABEL',
        value: '0 (30 49 22 0) "DAMAGE" 1',
      },
      {
        key: 'LABEL',
        value: '0 (30 58 22 0) "P DEMAND" 1',
      },
      {
        key: 'LABEL',
        value: '0 (30 67 22 0) "P SUPPLY" 1',
      },
      {
        key: 'LABEL',
        value: '1002 (136 31 22 0) "2000" 1 right',
      },
      {
        key: 'LABEL',
        value: '1004 (136 40 22 0) "HEAVY" 1 right',
      },
      {
        key: 'LABEL',
        value: '1012 (136 58 22 0) "500" 1 right',
      },
      {
        key: 'LABEL',
        value: '1011 (136 67 22 0) "0" 1 right',
      },
      {
        key: 'LABEL',
        value: '1200 (30 127 93 12) "Building Limit Reached" 1 center',
      },
      {
        key: 'BUTTON',
        value: '2000 (86 124 34 12) "Build" 2',
      },
      {
        key: 'BUTTON',
        value: '2001 (124 124 34 12) "Close" 2',
      },
      {
        key: 'PIPMETER',
        value: '1101 (64 31 71 9)',
      },
      {
        key: 'PIPMETER',
        value: '1104 (64 40 71 9)',
      },
      {
        key: 'DAMAGEMETER',
        value: '1105 (64 49 94 9)',
      },
      {
        key: 'PIPMETER',
        value: '1112 (64 58 71 9)',
      },
      {
        key: 'PIPMETER',
        value: '1111 (64 67 71 9)',
      },
    ],
  },
  {
    name: '1018',
    props: [
      {
        key: 'FORM',
        value: '(0 0 320 320) 2001',
      },
      {
        key: 'BUTTON',
        value: '2000 (120 135 10 12) "" 2 nocenter okup.tbm okdown.tbm',
      },
      {
        key: 'BUTTON',
        value: '2001 (0 135 10 12) "" 2 nocenter cancelup.tbm canceldown.tbm',
      },
    ],
  },
  {
    name: '1030',
    props: [
      {
        key: 'FORM',
        value: '(0 0 66 51) 2001',
      },
      {
        key: 'LABEL',
        value: '1200 (0 2 66 0) "" 3 center',
      },
    ],
  },
  {
    name: '1031',
    props: [
      {
        key: 'FORM',
        value: '(0 0 66 51) 2001',
      },
      {
        key: 'LABEL',
        value: '1200 (0 2 66 0) "" 3 center',
      },
      {
        key: 'BUTTON',
        value: '1306 (3 14 60 12) "Transform" 2',
      },
      {
        key: 'LABEL',
        value: '1201 (2 14 62 24) "Can\'t Transform. Move to clear area." 1 left multiline',
      },
    ],
  },
  {
    name: '1032',
    props: [
      {
        key: 'FORM',
        value: '(0 0 66 51) 2001',
      },
      {
        key: 'LABEL',
        value: '1200 (0 2 66 0) "" 3 center',
      },
      {
        key: 'BUTTON',
        value: '1306 (3 14 60 12) "Deliver" 2',
      },
    ],
  },
  {
    name: '1045',
    props: [
      {
        key: 'FORM',
        value: '(0 0 160 143) 2001',
      },
      {
        key: 'LABEL',
        value: '0 (2 5 82 0) "R&D TECHNOLOGIES" 3',
      },
      {
        key: 'BUTTON',
        value: '2004 (135 3 10 12) "" 2 nocenter helpup.tbm helpdown.tbm',
      },
      {
        key: 'BUTTON',
        value: '2001 (147 3 10 12) "" 2 nocenter cancelup.tbm canceldown.tbm',
      },
      {
        key: 'ANIMLIST',
        value: '1007 (-1 17 28 121) 1 18',
      },
      {
        key: 'LABEL',
        value: '1001 (30 19 75 0) "UPGRADE NAME" 1',
      },
      {
        key: 'LABEL',
        value: '1203 (30 31 22 0) "COST" 1',
      },
      {
        key: 'LABEL',
        value: '1002 (136 31 22 0) "2000" 1 right',
      },
      {
        key: 'LABEL',
        value: '1010 (30 49 127 8) "" 1 left multiline',
      },
      {
        key: 'LABEL',
        value: '1202 (30 97 22 0) "PREREQUISITES" 1',
      },
      {
        key: 'LABEL',
        value: '1201 (30 106 127 8) "" 1 left multiline',
      },
      {
        key: 'BUTTON',
        value: '2000 (78 124 42 12) "Research" 2',
      },
      {
        key: 'BUTTON',
        value: '2001 (124 124 34 12) "Close" 2',
      },
      {
        key: 'PIPMETER',
        value: '1101 (64 31 71 9)',
      },
    ],
  },
];
